// Set up all fields and multiple validators for each
import React from "react";
import * as yup from "yup";
import { Grid } from "@mui/material";
import { keyFromIdentity } from "../helpers";
import { QuestionProps } from "../question";
import OutlinedDiv from "./outlined";
import TextInput from "./text";
import UsState from "./us-state";

export const initial = (
  question: QuestionProps,
  _questionsMap: Record<string, QuestionProps>,
  parent?: string,
  index?: number,
): Record<string, Record<string, string>> => {
  const parentName = keyFromIdentity(question.identity, parent, index);
  return {
    [parentName]: {
      address1: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
    },
  };
};

export const validator = (
  question: QuestionProps,
  _questionsMap: Record<string, QuestionProps>,
  parent?: string,
  index?: number,
): Record<string, yup.AnySchema> => {
  const parentName = keyFromIdentity(question.identity, parent, index);
  const value = yup.string();
  const zip = yup.string()
    .matches(/^[0-9]+$/, "Must be only digits")
    .min(5, "Must be exactly 5 digits")
    .max(5, "Must be exactly 5 digits");
  return {
    [parentName]: yup.object().shape({
      "address1": question.required ? value.required() : value,
      "address2": value,
      "state": question.required ? value.required() : value,
      "city": question.required ? value.required() : value,
      "zip": question.required ? zip.required() : zip,
    }),
  };
};

const AddressInput = (props: any) => {
  const { name: parentName } = props;
  const address1 = `${parentName}.address1`;
  const address2 = `${parentName}.address2`;
  const city = `${parentName}.city`;
  const state = `${parentName}.state`;
  const zip = `${parentName}.zip`;
  return (<OutlinedDiv label={props.title} fullWidth required={props.required}>
    <Grid container spacing={1} >
      <Grid size={{ xs: 12 }}>
        <TextInput {...props} name={address1} title="Address"/>
      </Grid>
      <Grid size={{ xs: 12, lg: 6 }}>
        <TextInput {...props} name={address2} title="Apt/ste" required={false} />
      </Grid>
      <Grid size={{ xs: 12, lg: 6 }}>
        <TextInput {...props} name={city} title="City" />
      </Grid>
      <Grid size={{ xs: 12, lg: 8 }}>
        <UsState {...props} name={state} title="State" />
      </Grid>
      <Grid size={{ xs: 12, lg: 4 }}>
        <TextInput {...props} name={zip} title="ZIP" />
      </Grid>
    </Grid>
  </OutlinedDiv>);
};

AddressInput.initial = initial;
AddressInput.validator = validator;
export default AddressInput;
